import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Optional, Output, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { formConfigs } from '@app/shared/utils';

const defaultConfig = {
  isARequiredField: true,
  autocomplete: 'off',
  minlength: formConfigs.twelve,
  maxlength: formConfigs.fifty,
  minUpperCaseLength: formConfigs.one,
  minLowerCaseLength: formConfigs.one,
  minSpecialCharacterLength: formConfigs.one,
  classNames: 'form-control fidelity-form-input',
  index: '',
  type: 'text',
  label: '',
  shouldShowPasswordIndicatorsPopup: true,
  shouldShowPasswordEyeSymbol: true,
  labelClass:'',
  labelStyle:{},
  passwordEyeStyle : { 'position': 'absolute', 'top': '36px', 'right': '15px' }
}
@Component({
  selector: 'password-custom-control',
  templateUrl: './password-custom-control.component.html',
  styleUrls: ['./password-custom-control.component.scss']
})

export class PasswordCustomControlComponent implements ControlValueAccessor {
  @Input() isARequiredField = defaultConfig.isARequiredField;
  @Input() autocomplete = defaultConfig.autocomplete;
  @Input() minlength = defaultConfig.minlength;
  @Input() maxlength = defaultConfig.maxlength;
  @Input() minUpperCaseLength = defaultConfig.minUpperCaseLength;
  @Input() minLowerCaseLength = defaultConfig.minLowerCaseLength;
  @Input() minSpecialCharacterLength = defaultConfig.minSpecialCharacterLength;
  @Input() label = defaultConfig.label;
  @Input() index = defaultConfig.index;
  @Input() classNames = defaultConfig.classNames;
  @Input() extraClassNames;
  @Input() type = defaultConfig.type;
  @Input() shouldShowPasswordIndicatorsPopup = defaultConfig.shouldShowPasswordIndicatorsPopup;
  @Input() shouldShowPasswordEyeSymbol = defaultConfig.shouldShowPasswordEyeSymbol;
  @Input() labelClass=defaultConfig.labelClass;
  @Input() labelStyle=defaultConfig.labelStyle;
  @Input() passwordEyeStyle = defaultConfig.passwordEyeStyle;
  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() input: EventEmitter<any> = new EventEmitter();
  @Output() keyup: EventEmitter<any> = new EventEmitter();
  @Output() keypress: EventEmitter<any> = new EventEmitter();
  @Output() keydown: EventEmitter<any> = new EventEmitter();

  isPasswordShow = false;
  showIndicators = false;
  passwordLengthValid: boolean = false;
  uppercaseValid: boolean = false;
  lowercaseValid: boolean = false;
  specialCharacterValid: boolean = false;

  onRegisterChange = () => { };
  onRegisterTouched = () => { };

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // Only prevent space in the password field itself; document:keypress would otherwise block space in all form fields
    if (event?.code === 'Space' && this.elementRef?.nativeElement?.contains(event.target as Node)) {
      event.preventDefault();
    }
  }

  constructor(
    @Self() @Optional() public ngControl: NgControl,
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef<HTMLElement>
  ) {
    if (ngControl != null) {
      ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    this.ngControl.control.valueChanges.subscribe((value) => {
      this.passwordLengthValid = value.length >= this.minlength;
      this.uppercaseValid = this.validatePasswordCharacters(value, /[A-Z]+/g, new RegExp(`.*[A-Z]{${this.minUpperCaseLength},}`));
      this.lowercaseValid = this.validatePasswordCharacters(value, /[a-z]+/g, new RegExp(`.*[a-z]{${this.minLowerCaseLength},}`));
      this.specialCharacterValid = this.validatePasswordCharacters(value, /[!@#$%^&*]+/g, new RegExp(`.*[!@#$%^&*]{${this.minSpecialCharacterLength},}`));
      if (this.passwordLengthValid && this.uppercaseValid && this.lowercaseValid && this.specialCharacterValid) {
        this.ngControl.control.setErrors(null, { emitEvent: false });
      }
      else {
        this.ngControl.control.setErrors(value == "" ? { required: true } : { invalid: true }, { emitEvent: false });
      }
    });
  }

  validatePasswordCharacters(value: string, matchingRegExp, regExp: RegExp) {
    let mergedCharacters = "", isValid = false;
    value.match(matchingRegExp)?.forEach((word: string, index) => {
      mergedCharacters += word;
      if (value.match(matchingRegExp).length == index + 1) {
        isValid = regExp.test(mergedCharacters);
      }
    });
    return isValid;
  }

  writeValue(obj: any) {
  }

  registerOnChange(fn: any) {
    this.onRegisterChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onRegisterTouched = fn;
  }

  setDisabledState?(isDisabled: boolean) {
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
}